//*Importing Libraries from React
import React, { useRef } from "react";

//*Importing components from react-bootstrap
import { Button, FormControl, InputGroup } from "react-bootstrap";

//*Importing icons from react-icons
import { AiOutlineSearch } from "react-icons/ai";
import { Icon } from "../../components/common/Icon";

const Search = React.forwardRef((props: any, ref) => {
  const inputRef = useRef(null);

  return (
    <InputGroup
      className={`${props.className}`}
      style={{ width: "50%", height: "max-content" }}
    >
      <FormControl
        ref={inputRef}
        placeholder={props.placeholder}
        data-testid="search-input"
        value={props.inputValue ?? ""}
        onChange={(e) => {
          if (!props.WaitConfirm)
            props.ValueChange && props.ValueChange(e.target.value);
        }}
      />      <Button
        variant="outline-secondary"
        onClick={() =>
          props.ValueChange && props.ValueChange(props.input_value)
        }
      >
        <Icon icon={AiOutlineSearch} />
      </Button>
    </InputGroup>
  );
});

export default Search;
